// FWSD-5138
export const VehicleDataUsageAllowance = [
	{ value: 75, label: '75%' },
	{ value: 85, label: '85%' },
	{ value: 95, label: '95%' },
	{ value: 100, label: '100%' },
]

export const VehicleMaxDataOverage = [
	{ value: 10, label: '10%' },
	{ value: 20, label: '20%' },
	{ value: 40, label: '40%' },
	{ value: 50, label: '50%' },
	{ value: 75, label: '75%' },
	{ value: 85, label: '85%' },
	{ value: 95, label: '95%' },
	{ value: 100, label: '100%' },
]
